export type SaleConfig = {
  subtitle: string;
};
export type BrandConfigDTO = {
  id: number;
  sourceSet: string[];
};
export type SectionDTO = {
  title: string;
  subtitle: string;
  buttonText: string;
  categoryId: number;
};
export type HomeConfig = {
  sections: SectionDTO[];
  brands: BrandConfigDTO[];
};
export type PageConfig = {
  sale: SaleConfig;
  home: HomeConfig;
};
